import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://api-inventory.neuromotion.tech/api/v1/dashboard';

export const dashboardTotal = createAsyncThunk(
  'dashboard/dashboardTotal',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/total`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    dashboardtotals: null,
    loading: false,
    error: null,
    message: false
  },
  reducers: {
       clearError: (state) => {
        state.error = null;
      },
      clearMessage: (state) => {
        state.message = null;
      }
  },
  extraReducers: (builder) => {
    builder.addCase(dashboardTotal.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(dashboardTotal.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardtotals = action.payload;
    });
    builder.addCase(dashboardTotal.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });

  }
});
export const { clearError, clearMessage } = dashboardSlice.actions;

export default dashboardSlice.reducer;
